export const selectPredictionsLength = (state) =>
  state.dashboard.predictionsLength || 0;
export const selectPromisesLength = (state) =>
  state.dashboard.promisesLength || 0;
export const selectIsLoading = (state) => state.dashboard.isLoading;
export const selectPredictorsLength = (state) =>
  state.dashboard.predictorsLength || 0;
export const selectSurveysLength = (state) =>
  state.dashboard.surveysLength || 0;
